/**
 * @Author: v_jppjpeng
 * @Date: 2022-10-24 15:18:17
 * @Explain: 路由配置表
 */

export default {
  INDEX: '/',
  /** admin */
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgotPassword',
  WELCOME_PAGE: '/welcomePage',
  VIEW_TEMPLATE: '/viewTemplate',
  /** 无权限页面 */
  NO_AUTH_PAGE: '/noPermission',

  /** 主页 */
  HOME: '/home',

  /** 活动管理 - 活动列表 */
  ACTIVITY_MANAGE_LIST: '/campaigns/activityManage/list',
  /** 活动管理 - 创建活动(新增，编辑) */
  ACTIVITY_MANAGE_CREATE: '/campaigns/activityManage/create',
  /** 活动管理 - 活动详情 */
  ACTIVITY_MANAGE_DETAILS: '/campaigns/activityManage/details',
  /** 活动管理 - 审批列表 */
  ACTIVITY_APPROVAL_LIST: '/campaigns/activityApproval/list',
  /** 活动管理 - 审批详情 */
  ACTIVITY_APPROVAL_DETAILS: '/campaigns/activityApproval/details',
  /** 活动管理 - A/B 测试 - 列表 */
  ACTIVITY_AB_TEST_LIST: '/campaigns/activityAbTest/list',
  /** 活动管理 - A/B 测试 - 创建、编辑 */
  ACTIVITY_AB_TEST_CRETE: '/campaigns/activityAbTest/create',
  /** 活动管理 - A/B 测试 - 详情 */
  ACTIVITY_AB_TEST_DETAILS: '/campaigns/activityAbTest/details',
  /** 活动管理 - A/B 测试 - 审批详情 */
  ACTIVITY_AB_TEST_APPROVAL_DETAILS:
    '/campaigns/activityApproval/approvalDetails',
  /** 活动管理 - 旧版A/B 测试 - 创建、编辑 */
  OLD_ACTIVITY_AB_TEST_CRETE: '/campaigns/activityAbTestOld/create',
  /** 活动管理 - 旧版A/B 测试 - 详情 */
  OLD_ACTIVITY_AB_TEST_DETAILS: '/campaigns/activityAbTestOld/details',
  /** 活动管理 - WhatsApp - 列表 */
  ACTIVITY_WHATSAPP_LIST: '/campaigns/activityWhatsApp/list',
  /** 活动管理 - WhatsApp - 创建、编辑 */
  ACTIVITY_WHATSAPP_CRETE: '/campaigns/activityWhatsApp/create',
  /** 活动管理 - WhatsApp - 详情 */
  ACTIVITY_WHATSAPP_DETAILS: '/campaigns/activityWhatsApp/details',
  /** 活动管理 - 周期活动 - 列表 */
  ACTIVITY_CYCLE_LIST: '/campaigns/activityCycle/list',
  /** 活动管理 - 周期活动 - 创建、编辑 */
  ACTIVITY_CYCLE_CRETE: '/campaigns/activityCycle/create',
  /** 活动管理 - 周期活动 - 详情 */
  ACTIVITY_CYCLE_DETAILS: '/campaigns/activityCycle/details',
  /** 活动管理 - 自动化活动 - 列表 */
  ACTIVITY_AUTO_LIST: '/campaigns/activityAuto/list',
  /** 活动管理 - 自动化活动 - 创建、编辑 */
  ACTIVITY_AUTO_CRETE: '/campaigns/activityAuto/create',
  /** 活动管理 - 自动化活动 - 详情 */
  ACTIVITY_AUTO_DETAILS: '/campaigns/activityAuto/details',
  /** 活动管理 - 用户旅程 - 列表 */
  USER_JOURNEY_LIST: '/campaigns/userJourney/list',
  /** 活动管理 - 用户旅程 - 创建、编辑 */
  USER_JOURNEY_CRETE: '/campaigns/userJourney/create',
  /** 活动管理 - 用户旅程 - 详情 */
  USER_JOURNEY_DETAILS: '/campaigns/userJourney/details',

  /** 联系人管理 - 列表 */
  CONTACT_MANAGE_LIST: '/contacts/contactManage/list',
  /** 联系人管理 - 导入历史 */
  CONTACT_MANAGE_IMPORT_HISTORY: '/contacts/contactManage/importHistory',
  /** 联系人管理 - 删除历史 */
  CONTACT_MANAGE_DELETE_HISTORY: '/contacts/contactManage/deleteHistory',
  /** 字段设置 - 列表 */
  CONTACT_MANAGE_FIELD_SETTINGS: '/contacts/contactManage/fieldSettings',
  /** 字段设置 - 发送详情 */
  CONTACT_MANAGE_FIELD_SETTINGS_SEND_DETAILS:
    '/contacts/contactManage/sendDetails',
  /** 联系人管理 -  详情 */
  CONTACT_MANAGE_DETAILS: '/contacts/contactManage/details',
  /** 联系人管理 -  新增编辑 */
  CONTACT_MANAGE_ADD_EDIT: '/contacts/contactManage/addOrEdit',
  /** 联系人管理 -  新增编辑 导入CSV文件 - 上传文件 */
  CONTACT_MANAGE_ADD_EDIT_IMPORT_CSV_UPLOAD_FILE:
    '/contacts/contactManage/addOrEdit/importCsv/uploadFile',
  /** 联系人管理 -  新增编辑 导入CSV文件 - whatsApp上传文件 */
  CONTACT_MANAGE_ADD_EDIT_IMPORT_CSV_WHATSAPP_UPLOAD_FILE:
    '/contacts/contactManage/addOrEdit/importCsvWhatsApp/uploadFile',
  /** 联系人管理 -  新增编辑 导入CSV文件 - 匹配字段 */
  CONTACT_MANAGE_ADD_EDIT_IMPORT_CSV_MATCH_ATTRIBUTE:
    '/contacts/contactManage/addOrEdit/importCsv/matchAttribute',
  /** 联系人管理 -  新增编辑 导入CSV文件 - 更新联系人 */
  CONTACT_MANAGE_ADD_EDIT_IMPORT_CSV_UPDATE_CONTACTS:
    '/contacts/contactManage/addOrEdit/importCsv/updateContacts',
  /** 联系人管理 -  新增编辑 导入CSV文件 - 订阅状态 */
  CONTACT_MANAGE_ADD_EDIT_IMPORT_CSV_STATUS:
    '/contacts/contactManage/addOrEdit/importCsv/status',
  /** 联系人管理 -  新增编辑 导入CSV文件 - 偏好设置 */
  CONTACT_MANAGE_ADD_EDIT_IMPORT_CSV_PREFERENCE:
    '/contacts/contactManage/addOrEdit/importCsv/preference',
  /** 联系人管理 -  新增编辑 导入CSV文件 - 标签绑定 */
  CONTACT_MANAGE_ADD_EDIT_IMPORT_CSV_TAG:
    '/contacts/contactManage/addOrEdit/importCsv/tag',
  /** 联系人管理 -  新增编辑 导入CSV文件 - 检查 */
  CONTACT_MANAGE_ADD_EDIT_IMPORT_CSV_REVIEW:
    '/contacts/contactManage/addOrEdit/importCsv/review',
  /** 联系人管理 -  新增编辑 手动添加单个联系人 */
  CONTACT_MANAGE_ADD_EDIT_MUMAL: '/contacts/contactManage/addOrEdit/manual',
  /** 联系人管理 -  新增编辑 预约设置 */
  CONTACT_MANAGE_ADD_EDIT_NEWSLETTER:
    '/contacts/contactManage/addOrEdit/newsletter',

  /** 分层管理 - 列表 */
  SEGMENTS_MANAGE_LIST: '/contacts/segmentsManage/list',
  /** 分层管理 - 新增，编辑，详情 */
  SEGMENTS_MANAGE_ADD_EDIT: '/contacts/segmentsManage/addOrEdit',

  /** 标签管理 - 列表 */
  LABEL_MANAGE_LIST: '/contacts/labelManage/list',
  /** 标签管理 - 预测标记 */
  LABEL_MANAGE_LIST_PREDICTIVE_TAGS: '/contacts/labelManage/predictiveTags',

  /** 偏好设置 - 列表 */
  PREFERENCE_MANAGE_SETTING: '/contacts/preferenceManage/preferenceSetting',

  /** 联系人报表 */
  CONTACT_REPORT: '/contacts/contactReport',
  /** 联系人管理 - 列表 */
  SIGN_UP_FORM_LIST: '/contacts/signUpFormManage/list',
  /** 联系人管理 -  新增编辑 */
  SIGN_UP_FORM_ADD_EDIT: '/contacts/signUpFormManage/addOrEdit',

  /** 邮件模板 - 营销 */
  MAIL_TEMPLATE_MARKETING_LIST: '/mailTemplate/marketing/list',
  MAIL_TEMPLATE_MARKETING_CREATE: '/mailTemplate/marketing/create',
  MAIL_TEMPLATE_MARKETING_ADD_EDIT: '/mailTemplate/marketing/addOrEdit',
  /** 邮件模板 - 事务 */
  MAIL_TEMPLATE_TRANSACTIONAL_LIST: '/mailTemplate/transactional/list',
  MAIL_TEMPLATE_TRANSACTIONAL_CREATE: '/mailTemplate/transactional/create',
  MAIL_TEMPLATE_TRANSACTIONAL_ADD_EDIT: '/mailTemplate/transactional/addOrEdit',

  /** WhatsApp 模板 */
  WHATSAPP_TEMPLATE_LIST: '/content/whatsAppTemplate/list',
  WHATSAPP_TEMPLATE_ADD_OR_EDIT: '/content/whatsAppTemplate/addOrEdit',
  /** 占位符管理 - 列表 */
  PLACEHOLDER_MANAGE_LIST: '/content/placeholderManage/list',
  /** 占位符管理 - 详情 */
  PLACEHOLDER_MANAGE_DETAILS: '/content/placeholderManage/details',

  /** 活动报表 - 列表 */
  ACTIVITY_REPORT_LIST: '/report/activityReport/list',
  /** 活动报表 */
  ACTIVITY_REPORT: '/report/activityReport',
  /** 活动报表 - 分组报表详情 */
  ACTIVITY_GROUP_REPORT: '/report/activityGroupReport',
  /** 活动报表 - 导出链接导出页面 */
  ACTIVITY_REPORT_LINKS_CLICKED: '/report/linksClicked',

  /** 设置管理 */
  SETTING_MANAGE: '/settingManage',
  /** 设置管理 - 域名 - 列表 */
  SETTING_MANAGE_DOMAIN_AUTH_LIST: '/settingManage/domainAuth/list',
  /** 设置管理 - 域名 - 新增、编辑 */
  SETTING_MANAGE_DOMAIN_AUTH_ADD_EDIT: '/settingManage/domainAuth/addOrEdit',
  /** 设置管理 - 域名 - 详情 */
  SETTING_MANAGE_DOMAIN_AUTH_DETAILS: '/settingManage/domainAuth/details',
  /** 设置管理 - 发件地址 - 列表 */
  SETTING_MANAGE_SENDER_ADDRESS_LIST: '/settingManage/senderAddress/list',
  /** 设置管理 - 发件人 - 列表 */
  SETTING_MANAGE_SENDER_NAME_LIST: '/settingManage/senderName/list',
  /** 设置管理 - 拒绝 - 列表 */
  SETTING_MANAGE_REJECT_LIST: '/settingManage/rejectList/list',
  /** 设置管理 - 发送频率控制 - 配置 */
  SETTING_MANAGE_SENDING_FREQUENCY_CONTROL:
    '/settingManage/sendingFrequencyControl/config',
  /** 设置管理 - API-KEY - 列表 */
  SETTING_MANAGE_API_KEY_LIST: '/settingManage/apiKey/list',
  /** 设置管理 - API-KEY - 详情 */
  SETTING_MANAGE_API_KEY_DETAILS: '/settingManage/apiKey/details',
  /** 设置管理 - API-KEY - 设置 */
  SETTING_MANAGE_API_KEY_SETTING: '/settingManage/apiKey/setting',
  /** 设置管理 - 网络钩子 - 列表 */
  SETTING_MANAGE_WEB_HOOKS_LIST: '/settingManage/webhooks/list',
  /** 设置管理 - 测试邮箱 - 列表 */
  SETTING_MANAGE_TEST_MAIL_LIST: '/settingManage/testList/list',
  /** 设置管理 - 区域管理 - 列表 */
  SETTING_MANAGE_AREA_LIST: '/settingManage/areaManage/list',
  /** 设置管理 - 二次确认邮件配置 */
  SETTING_MANAGE_DOUBLE_OPT_IN_CONFIG: '/settingManage/doubleOptIn/config',
  /** 用户管理 - 编辑 */
  USER_MANAGE_LIST: '/settingManage/userManage',
  /** 用户管理 - 编辑 */
  USER_MANAGE_ADD_OR_EDIT: '/settingManage/userManage/addOrEdit',
  /** 用户管理 - 个人资料 */
  USER_MANAGE_MY_PROFILES: '/settingManage/userManage/myProfiles',
  /** 版本 */
  VERSIONS: '/settingManage/versions',

  /** 业务管理 - 创建业务或加入业务 */
  BUSINESS_MANAGE_CREATE: '/businessManage/create',
  /** 业务管理 - 加入业务 */
  BUSINESS_MANAGE_JOIN: '/businessManage/joinProject',
  /** 业务管理 - 我的项目 */
  BUSINESS_MANAGE_MY_PROJECT_LIST: '/businessManage/list',

  /** 测试玩家管理模块 - 测试人列表 */
  TESTER_MANAGE_LIST: '/testerManage/list',
  /** 测试玩家管理模块 - 测试配置 */
  TESTER_MANAGE_ADD_OR_EDIT: '/testerManage/addOrEdit',
  /** 测试玩家管理模块 - 测试管理列表 */
  TESTER_MANAGE_TEST_MANAGE_LIST: '/testerManage/testManageList',

  /** 公共 - 无权限 */
  NO_PERMISSION: '/common/noPermission',
  /** 公共 - 中转 */
  TRANSFER: '/common/transfer',
  /** 导出中心 **/
  EXPORT_CENTER_LIST: '/exportCenter/list',
};
